import { IconBox } from "./IconBox";
import { ReactComponent as Sun } from '../../assets/icon/Header/icon-sun.svg';
import { ReactComponent as Moon } from '../../assets/icon/Header/icon-moon.svg';

//日夜模式圖案
export const IconSun = (props) => <IconBox {...props} Icon={Sun} />
export const IconMoon = (props) => <IconBox {...props} Icon={Moon} />